import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Left – copyright */}
        <p className="footer-copyright">
          &copy; {currentYear} Sankavitha Solutions. All rights reserved.
        </p>

        {/* Centre – contact details */}
        <div className="footer-contact">
          <a href="mailto:sales@sankavitha.com" className="footer-contact-item">
            <span className="footer-contact-icon">✉</span>
            sales@sankavitha.com
          </a>
          <span className="footer-contact-divider">|</span>
          <a href="tel:+919976747369" className="footer-contact-item">
            <span className="footer-contact-icon">📞</span>
            +91 99767 47369
          </a>
          <span className="footer-contact-divider">|</span>
          <span className="footer-contact-item footer-location">
            <span className="footer-contact-icon">📍</span>
            Coimbatore, Tamil Nadu, India
          </span>
        </div>

        {/* Right – social links */}
        <div className="footer-social">
          <a
            href="https://www.linkedin.com/company/sankavitha-solutions/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
            title="LinkedIn"
          >
            in
          </a>
          <a
            href="mailto:sales@sankavitha.com"
            className="social-icon"
            title="Send Email"
          >
            ✉
          </a>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
